export const registeredSMSRateManagement = (builder) => ({
    registeredSMSRateManagement: builder.mutation({
        query: ({ data, search, pageNumber, limit, sortBy, sortOrder, }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

            return {
                url: '/get_smsc_rate_list',
                method: 'GET',
                params: {
                    data,
                    search,
                    pageNumber,
                    limit,
                    sortBy, sortOrder,
                },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});

